/** 仅内网时的域名 */
export var BATCH_REQ_PATH = '/hornNew';
/** 仅内网时的域名 */
export var SINGLE_REQ_PATH = '/horn';
/** 公网域名（兜底） */
export var PUBLIC_HOST = 'https://portal-portm.meituan.com';
/** 仅内网时的域名 */
export var INTRANET_HOST = 'https://h.vip.sankuai.com';
/** 一分钟 */
export var ONE_MINS = 10 * 1000 * 6;
//# sourceMappingURL=const.js.map